import { FC } from 'react';
import { IFormProps } from '.';
import { PageContainerViewModel, PageViewModel } from '../Models';
import PageControl from './PageControl';

interface IPageContainerControlProps extends IFormProps {
	model: PageContainerViewModel;
	pageIndex: number;
}

const PageContainerControl: FC<IPageContainerControlProps> = (props) => {
	const { pageIndex = 0, model } = props;

	const renderPage = (page: PageViewModel, index: number) => {
		return (
			<PageControl
				key={'Page_' + index}
				{...props}
				model={page}
				hidden={index !== pageIndex}
			/>
		);
	};

	return <>{model.Pages.map(renderPage)}</>;
};

export default PageContainerControl;
